import { WidgetDataDto } from "./WidgetDataDto";
import { WidgetDataModel } from "./WidgetDataModel";

export const transformWidgetDataDtoToModel = (
  dto: WidgetDataDto
): WidgetDataModel => ({
  ...dto,
  fulfilledTimestamp: Date.now(),
});
